import React from "react";

const TopicManagementIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.823"
      height="18.404"
      viewBox="0 0 13.823 18.404"
    >
      <path
        id="Path_1334"
        data-name="Path 1334"
        d="M225.033,96H212.79a.792.792,0,0,0-.79.79v16.824a.792.792,0,0,0,.79.79h12.243a.792.792,0,0,0,.79-.79V96.79A.792.792,0,0,0,225.033,96Zm-9.636,6.714H219.5v1.58H215.4Zm7.425,5.766H215.4V106.9h7.425Z"
        transform="translate(-212 -96)"
        fill={fill ? fill : "#0051bc"}
      />
    </svg>
  );
};

export default TopicManagementIcon;

